module.exports = __webpack_public_path__ + "img/logoNew.963d5c1b.png";